<h1 mat-dialog-title>Add Observation Group</h1>

<form #form="ngForm">
	<mat-dialog-content>
		<div class=" flex-column gap-16 mt-8">
			<mat-form-field subscriptSizing="dynamic" class="w-100">
				<mat-label>Name</mat-label>
				<input matInput
					   autocomplete="off"
					   name="name"
					   [(ngModel)]="data.name"
                       #name="ngModel"
					   minlength="2"
					   maxlength="255"
					   required
					   cdkfocusinitial>
				@if (name.hasError('required')) {
					<mat-error>Name is required.</mat-error>
				}
				@if (name.hasError('minlength')) {
					<mat-error>Name has to have at least 2 characters.</mat-error>
				}
			</mat-form-field>

			<mat-form-field subscriptSizing="dynamic" class="w-100">
				<mat-label>Duration</mat-label>
				<input matInput
					   autocomplete="off"
					   name="duration"
					   [(ngModel)]="data.duration"
					   type="number"
					   [min]="0"
					   [max]="999"
					   [step]="1"
					   required>
				<mat-hint>Value in hours (e.g 1 = one hour and 0 = indefinite)</mat-hint>
			</mat-form-field>

			<div class="flex-row align-items-center">
				<div class="flex-grow-1 flex-column gap-0">
					<div>Map color</div>
					<div class="text-muted">Leave blank to use default color (recommended)</div>
				</div>
				@if (mapColor.value) {
					<button mat-icon-button
							matTooltip="Reset value to default"
							(click)="mapColor.reset( null)">
						<mat-icon>clear</mat-icon>
					</button>
				}
				<ngx-colors matSuffix
							ngx-colors-trigger
							colorsAnimation="popup"
							name="mapColor"
							#mapColor="ngModel"
							[(ngModel)]="data.mapColor"
							class="suffix">
				</ngx-colors>
			</div>
			<div>
				<mat-checkbox [(ngModel)]="data.isAudible"
							  name="isAudible"
							  [matTooltip]="'When enabled, audible alert is played on the device'">Audible Alert
				</mat-checkbox>
			</div>
		</div>
	</mat-dialog-content>

	<mat-dialog-actions>
		<button mat-stroked-button mat-dialog-close>
			Cancel
		</button>
		<button mat-flat-button
				type="submit"
				[mat-dialog-close]="data"
				[disabled]="form.invalid">
			Add Group
		</button>
	</mat-dialog-actions>
</form>
